import {StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GRAY_DARKER, RED_LIGHT} from 'ui-library/Colors';
import {ElementMouseEvent} from 'util/Types';

import ClickableIcon, {ClickableIconStyle} from './ClickableIcon';

interface DeleteIconProps {
  /**
   * Icon to display.
   *
   * Generally:
   * - `trash-can` should be used for deleting objects (e.g. file, table, entry, etc.)
   * - `cross-thick` should be used for removing an item from a list
   */
  icon: 'trash-can' | 'cross-thick';
  disabled?: boolean;
  onClick?: (e: ElementMouseEvent) => void;
  dataTestAttrs?: DataTestAttrs;
}

/** Render a delete icon (either a trash can or x-mark) with an onClick callback */
export default function DeleteIcon({icon, disabled, onClick, dataTestAttrs}: DeleteIconProps): JSX.Element {
  return (
    <ClickableIcon
      icon={icon}
      onClick={onClick}
      disabled={disabled}
      dataTestAttrs={dataTestAttrs}
      iconStyle={ClickableIconStyle.NEGATIVE}
      className={classNames(
        css(deleteIconStyles.deleteIcon),
        !disabled && icon === 'trash-can' && css(deleteIconStyles.trashCanHover),
        !disabled && icon === 'cross-thick' && css(deleteIconStyles.crossThickHover)
      )}
    />
  );
}

/** @package */
export const deleteIconStyles = StyleSheet.create({
  deleteIcon: {
    width: 16,
    height: 16,
  },
  trashCanHover: {
    ':hover': {
      color: RED_LIGHT,
    },
  },
  crossThickHover: {
    ':hover': {
      color: GRAY_DARKER,
    },
  },
});
